import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from '../common';
import { Observable } from 'rxjs';

export const BASE = `${API_URL}`;
const BASE_URL = `${API_URL}/api/ICD10/`;
const BASE_URL_ICD9 = `${API_URL}/api/ICD9/`;
const FEED_BACK_ICD = `${API_URL}/api`;

@Injectable({
    providedIn: 'root',
})
export class IcdService {

    constructor(private httpClient: HttpClient) {
     
    }

    quickFeedback(feedbackData: any, appname: string) {
        // return this.httpClient.post<any>(`${FEED_BACK_ICD}/feedback/`, feedbackData);
        // Add X-CSRFToken to the header
        let csrftoken: string = ''; // Assigning a default value
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
        return this.httpClient.post<any>(`${FEED_BACK_ICD}/${appname}/feedback/`, feedbackData, {
            headers: { 'X-CSRFToken': csrfToken },
        });
    }
 

    submitFeedback(feedbackData: any) {
        // return this.httpClient.post<any>(`${FEED_BACK_ICD}/feedback/`, feedbackData);
        // Add X-CSRFToken to the header
        let csrftoken: string = ''; // Assigning a default value
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
        return this.httpClient.post<any>(`${FEED_BACK_ICD}/feedback/`, feedbackData, {
            headers: { 'X-CSRFToken': csrfToken },
        });
    }

    getListFeedback() {
        return this.httpClient.get<any>(`${FEED_BACK_ICD}/feedback/ICD9/`);
    }

    getListFeedback10() {
        return this.httpClient.get<any>(`${FEED_BACK_ICD}/feedback/ICD10/`);
    }

    getChapter(lang: string) {
        return this.httpClient.get<any>(`${BASE_URL}root?lang=${lang}`);
    }

    getDetailModel(model: string, id: string, lang: string) {
        // Tạo tiêu đề mới chứa địa chỉ IP của máy khách
        const headers = new HttpHeaders({
          'X-Client-IP': localStorage.getItem('client_ip') || ''
        });
    
        // Gửi yêu cầu HTTP với tiêu đề tùy chỉnh
        return this.httpClient.get<any>(
          `${BASE_URL}data/${model}?id=${id}&lang=${lang}`,
          { headers: headers }
        );
      }

    getChildrenOfModel(model: string, id: string, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL}childs/${model}?id=${id}&lang=${lang}`);
    }

    getChapter_ICD9(lang: string) {
        
        return this.httpClient.get<any>(`${BASE_URL_ICD9}root?lang=${lang}`);
    }

    getDetailModel_ICD9(model: string, id: string, lang: string) {
        const headers = new HttpHeaders({
            'X-Client-IP': localStorage.getItem('client_ip') || ''
          });
        return this.httpClient.get<any>(`${BASE_URL_ICD9}data/${model}?id=${id}&lang=${lang}`, {headers: headers });
    }

    getChildrenOfModel_ICD9(model: string, id: string, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL_ICD9}childs/${model}?id=${id}&lang=${lang}`);
    }

    getDocumentList(category: string) {
        return this.httpClient.get<any>(`${API_URL}/api/DOC/list/${category}`);
    }

    getDocumentDetails(id: number) {
        const headers = new HttpHeaders({
            'X-Client-IP': localStorage.getItem('client_ip') || ''
          });
        return this.httpClient.get(`${API_URL}/api/DOC/data/${id}`, {headers: headers });
    }
}
